/* hgn-side-cart-referral.js — moved verbatim from snippets/hgn-side-cart-referral.liquid on 2026-09-14 (page-weight:
   inline JS → theme asset, loaded synchronously at the same position so execution order
   and DOMContentLoaded timing are unchanged). EDIT THIS FILE, not the snippet.

   2026-09-23 (referral launch, REFERRAL-BUILD.md §22). Base = this repo copy,
   which is the verbatim move of the snippet body that is still sitting,
   un-rendered, in the live theme (md5 fea06b3a…). Changes:
     - MINT CONTRACT: the fold below adds the gift into _lastSavingsGbpCents /
       _lastSavingsCents, and those go to the worker as totalSavingsCents /
       presentmentCents. The totals therefore INCLUDE the gift. The main
       worker strips the claimed gift back out and puts back ONLY its own
       verified, capped figure (or nothing when the claim doesn't verify).
       It never adds a gift on top. Keep the fold exactly as it is.
     - Copy: "£10 in Nail Points" (fx token via HGN.applyCurrency), Name
       Share asks for the friend's full name, gender-neutral throughout.
     - IR-1 kit nudge (_applyKitNudge, live since 09-20) is suppressed
       while a claim is live, the same way the pair card is.
     - Empty bag: the banner sits inside the empty state, clear of the
       close button (render 06).

   2026-10-07 (side cart declutter, redesigned/SIDECART-DECLUTTER-2026-10-07.md),
   both arms: the "Sent by a friend?" Name Share row is no longer painted;
   a shopper who arrived on a friend's link without claiming gets one line
   to the landing page instead (_renderReferralPrompt). The banner, the fold,
   the returning-customer ask, the suppressions and the mint fields are
   unchanged.

   2026-10-26 (multipacks D2, redesigned/multipacks/PASTE-MULTIPACK-TEMPLATE.md):
   a Multipack or a Matching Tips & Toes set (`isPackOrSet`, the kit rule) is
   never a "set" here: it doesn't count towards the two, is never the free
   one, and is `isSet: false` in the mint lines. The banner says so when one
   is in the bag. Base = live 3d5c02d4. */

(function () {
  'use strict';

  var B = window.__hgnSideCartBridge;
  if (!B || !B.HGNSideCart) return;
  /* Load once — a second copy would wrap the prototype twice and fold
     the gift twice (same guard as the attach snippet). */
  if (B.HGNSideCart.prototype.__hgnReferralLoaded) return;
  B.HGNSideCart.prototype.__hgnReferralLoaded = true;

  var HGNSideCart = B.HGNSideCart;
  var H = B.helpers || {};
  var escapeHtml = H.escapeHtml || function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var formatMoney = H.formatMoney || function (cents) { return '£' + (cents / 100).toFixed(2); };
  var isGiftLineItem = H.isGiftLineItem || function (it) {
    return !!(it && it.properties && it.properties._gift_line === '1');
  };

  /* ───────── copy (JS constants, never inline Liquid) ─────────
     `{first}` is substituted at render time; everything else is
     literal. The side cart has no schema of its own — the announcement
     bar owns its settings — so the strings live here, which is also
     where SIDE-CART.md §18 documents them. */
  var COPY = {
    bannerReady:      '{first}’s gift is applied — your second set is free',
    bannerReadyAnon:  'Your friend’s gift is applied — your second set is free',
    /* Kit build: the free unit is a design INSIDE the kit, so "second set"
       would describe a line the shopper can't see (render 04). */
    bannerReadyKit:     '{first}’s gift is applied — one design in your kit is free',
    bannerReadyKitAnon: 'Your friend’s gift is applied — one design in your kit is free',
    bannerNeedsOne:   'Add one more set and it’s free',
    bannerNeedsOneAnon: 'Add one more set and it’s free',
    /* 2026-10-26 (multipacks D2): a pack or a Matching Tips & Toes set in
       the bag is already priced as a deal, so it doesn't count towards the
       two sets. Said plainly, or a bag of two packs would read "Add one more
       set". `{deal}` = dealCopy below. */
    bannerDealNone:     '{first}’s gift is waiting — pick any two sets and the second one’s on us. {deal}',
    bannerDealNoneAnon: 'Your gift is waiting — pick any two sets and the second one’s on us. {deal}',
    bannerDealOne:      'Add one more set and it’s free. {deal}',
    dealPack:         'Packs are already a deal, so they don’t count.',
    dealMtt:          'Matching Tips & Toes sets are already a deal, so they don’t count.',
    dealBoth:         'Packs and Matching Tips & Toes sets are already a deal, so they don’t count.',
    bannerEmpty:      '{first}’s gift is waiting — pick any two sets, the second one’s on us',
    bannerEmptyAnon:  'Your gift is waiting — pick any two sets, the second one’s on us',
    rowFree:          'Free · {first}’s gift',
    rowFreeAnon:      'Free · your friend’s gift',
    nameShareTeaser:  'Sent by a friend? Claim your free set',
    nameSharePrompt:  'Type the full name of the friend who sent you',
    nameShareName:    'Your friend’s full name',
    nameShareEmail:   'Your email',
    nameShareRef:     'Your friend’s email address',
    nameShareCta:     'Claim my free set',
    nameShareMissing: 'Add your friend’s full name and your email.',
    nameShareAmbig:   'More than one person goes by that name. What’s your friend’s email address?',
    nameShareNone:    'We couldn’t find that name. Check the spelling, or add your friend’s email address.',
    nameShareErr:     'That didn’t go through. Try again in a moment.',
    /* Loyalty worker refusals (REFERRAL-BUILD §21): `referrer-excluded`
       (staff / test accounts) and `name-share-cap` (3 per referrer per 30
       days). The friend can still use the referrer's link. */
    nameShareRefused: 'That name can’t be used for a free set right now. Ask your friend to send you their link.',
    /* `{fx:10}` is the site-wide live-FX token (snippets/hgn-currency.liquid):
       HGN.applyCurrency() swaps it for £10 / €10 / CHF 10… in place, the same
       mechanism the header pill and the portal refer tab use. The credit is
       POINTS, not money, and it is once per friend (Matt, 09-23 headline). */
    referTitle:       'Give a friend a free set · get {fx:10} in Nail Points',
    referSub:         'They pick any two sets and the second one’s on us. The points are yours for every friend who orders.',
    referWa:          'WhatsApp',
    referShare:       'Share',
    referCopy:        'Copy link',
    referCopied:      'Copied',
    /* Arrived on a friend's link, nothing claimed yet (2026-10-07). */
    refPrompt:        'Your friend’s free set is waiting →'
  };
  function fill(tpl, first) {
    return String(tpl).replace('{first}', first || '');
  }
  /* Resolve `{fx:N}` tokens inside a freshly painted host. applyCurrency is
     the one converter every surface uses; the fallback only runs if the
     currency snippet hasn't loaded, and never leaves a raw token on screen. */
  function applyFx(host) {
    try {
      if (window.HGN && typeof window.HGN.applyCurrency === 'function') {
        window.HGN.applyCurrency(host);
        if (host.innerHTML.indexOf('{fx:') === -1) return;
      }
    } catch (e) {}
    try {
      var walker = document.createTreeWalker(host, NodeFilter.SHOW_TEXT, null);
      var n;
      while ((n = walker.nextNode())) {
        if (n.nodeValue.indexOf('{fx:') === -1) continue;
        n.nodeValue = n.nodeValue.replace(/\{fx:([0-9]+(?:\.[0-9]+)?)\}/g, function (_, v) {
          var gbp = parseFloat(v);
          try {
            if (window.HGN && typeof window.HGN.formatLive === 'function' &&
                typeof window.HGN.activeCurrencyKey === 'function') {
              return window.HGN.formatLive(gbp, window.HGN.activeCurrencyKey());
            }
          } catch (e) {}
          return '£' + gbp;
        });
      }
    } catch (e) {}
  }

  var API = (window.HGN && window.HGN.referral && window.HGN.referral.API) || 'https://points.holygrailnail.co';
  var ACCOUNT_ENDPOINT = 'https://holygrailnail.co/api/beans/account';

  function R() { return (window.HGN && window.HGN.referral) || null; }

  /* ───────── set-line maths ─────────
     One source for "is this a set": the same tier map the kit builder,
     the upsell and the IR-1 attach row use, so a product type that
     classifies as classic / gels / press-ons anywhere classifies as a
     set here. Kit (bundle) design lines carry those types too, which is
     exactly how a kit build earns "one design free". */
  var SET_TIERS = { classic: 1, gels: 1, 'press-ons': 1 };
  function tierOf(pt) {
    try {
      if (window.HGN && typeof window.HGN.tierFromProductType === 'function') {
        return window.HGN.tierFromProductType(pt);
      }
    } catch (e) {}
    return null;
  }
  function isOfferLine(it) {
    var p = it && it.properties;
    return !!(p && p._hgn_offer_kind);
  }
  /* A pack or a set (2026-10-26, multipacks D2): a Multipack or a Matching
     Tips & Toes set carries a range product type, so the tier map alone
     called it a "set" and the gift could take up to £19.99 off one. It is a
     Shopify component bundle (/cart.js `has_components: true`) already
     priced as a deal: it never counts as a set and is never the free one.
     ONE rule, the kit rule: HGN.kitProgress.isKitIneligible
     (snippets/hgn-kit-progress.liquid, loaded site-wide before this file),
     the same one assets/hgn-side-cart-attach.js uses. The fallback only runs
     if that snippet is missing. Call it on range-typed lines only. */
  function lc(s) { return String(s == null ? '' : s).toLowerCase(); }
  function isPackOrSet(it) {
    if (!it) return false;
    if (it.has_components === true) return true;
    try {
      var kp = window.HGN && window.HGN.kitProgress;
      if (kp && typeof kp.isKitIneligible === 'function') return !!kp.isKitIneligible(it);
    } catch (e) {}
    var h = lc(it.handle || it.product_handle), t = lc(it.product_title || it.title);
    return t.indexOf('pack') !== -1 || h.indexOf('pack') !== -1 || /matching\s+tips/.test(t) || h.indexOf('matching-') === 0;
  }
  function isSetLine(it) {
    return !!(it && !isGiftLineItem(it) && SET_TIERS[tierOf(it.product_type)] && !isPackOrSet(it));
  }
  /* Which deal lines sit in the bag, for the banner's "they don't count"
     clause: '' (none), 'pack', 'mtt' or 'both'. */
  function dealKind(cart) {
    var pack = false, mtt = false;
    ((cart && cart.items) || []).forEach(function (it) {
      if (!it || isGiftLineItem(it) || !SET_TIERS[tierOf(it.product_type)] || !isPackOrSet(it)) return;
      var t = lc(it.product_title || it.title), h = lc(it.handle);
      if (/matching\s+tips/.test(t) || h.indexOf('matching-') === 0) mtt = true; else pack = true;
    });
    return pack && mtt ? 'both' : pack ? 'pack' : mtt ? 'mtt' : '';
  }
  function unitRetail(it) {
    var q = Math.max(1, it.quantity || 1);
    var r = it.original_line_price != null ? it.original_line_price : (it.line_price || 0);
    return Math.round(r / q);
  }
  function setLines(cart) {
    return ((cart && cart.items) || []).filter(isSetLine);
  }
  /* Units, not lines: one line at qty 2 IS two sets, and "pick any two
     sets" is a promise about sets, not about rows in the drawer. */
  function setUnits(cart) {
    return setLines(cart).reduce(function (n, it) { return n + Math.max(1, it.quantity || 1); }, 0);
  }
  /* The gift line is the cheapest set UNIT. Pair / free-4th lines are
     skipped as candidates: their price is already folded by IR-1, so
     giving their retail away too would discount the same unit twice. */
  function giftCandidate(cart) {
    var best = null;
    setLines(cart).forEach(function (it) {
      if (isOfferLine(it)) return;
      var u = unitRetail(it);
      if (!u) return;
      if (!best || u < best.cents) best = { cents: u, item: it };
    });
    return best;
  }
  /* Same FX inversion the mint payload uses (attach's activeRate, which
     is the main file's fxRate by another name): presentment ÷ rate =
     GBP pence, identity on GBP carts. */
  function activeRate() {
    var k = (typeof H.activeKey === 'function') ? H.activeKey() : 'gbp';
    if (k === 'gbp') return 1;
    return (window.HGN && window.HGN.fxRates && window.HGN.fxRates[k]) || 0;
  }
  /* Nail Points and ad-hoc codes take their own checkout paths and
     neither mints our figure, so the gift must stand down the moment the
     intent flips — the same rule IR-1's `offersSuspended` follows. With
     the panels hidden (below) this should never fire; it exists because
     an intent can survive from an earlier session on the same cart. */
  function intentSuspended(cart) {
    var a = (cart && cart.attributes) || {};
    var v = a._hgn_discount_intent;
    if (v === 'nailpoints' || v === 'adhoc') return true;
    return ((cart && cart.discount_codes) || []).some(function (d) {
      return d && d.code && (/^NAILPOINTS-/i.test(d.code) || /^BEANS-/i.test(d.code));
    });
  }

  /* ───────── claim state ─────────
     Either signal counts (spec §6.1): the cart attribute is what
     orders/paid and the mint route read, localStorage is what carries the
     referrer's first name for the copy. */
  HGNSideCart.prototype._referralClaim = function () {
    var stored = null;
    /* The gift is for first orders. A signed-in customer who has ordered
       before never carries a claim into the mint, even one left in this
       browser (orders/paid would reject it anyway, but only after the
       free set is gone). Guests can't be told apart until checkout; the
       orders/paid check stays their backstop. */
    try { var r0 = R(); if (r0 && r0.isReturning()) return null; } catch (e) {}
    try { var r = R(); stored = r ? r.claim() : null; } catch (e) { stored = null; }
    var attr = '';
    try { attr = String(((this.cart || {}).attributes || {})._hgn_referral_claim || ''); } catch (e) { attr = ''; }
    if (!stored && !attr) return null;
    return {
      id:        (stored && stored.referral_id) || attr,
      firstName: (stored && stored.first_name) || '',
      code:      (stored && stored.code) || ''
    };
  };

  /* What the fold and the mint both read. `pres` is presentment cents,
     `gbp` is GBP pence — the two units the drawer and the worker speak. */
  HGNSideCart.prototype._referralGift = function () {
    var st = this._referralClaim();
    if (!st) return null;
    var cart = this.cart;
    var out = { claim: st, sets: 0, pres: 0, gbp: 0, item: null };
    if (!cart || !cart.item_count) return out;
    out.sets = setUnits(cart);
    out.deal = dealKind(cart);
    if (intentSuspended(cart)) return out;
    if (out.sets < 2) return out;
    var cand = giftCandidate(cart);
    if (!cand) return out;
    /* Safety clamp: total synthetic savings can never exceed what the
       bag is actually worth. A kit already discounted to its target
       price plus its cheapest design free is the case that gets close.
       The worker clamps again server-side; this keeps the DRAWER honest
       (and stops a negative subtotal ever being painted). */
    var kit5 = 0;
    try { if (typeof this._kit5FoldGbpCents === 'function') kit5 = Math.round((this._kit5FoldGbpCents() || 0) * (activeRate() || 1)); } catch (e) { kit5 = 0; }
    var cap = Math.max(0, (cart.items_subtotal_price || 0) - (this._lastSavingsCents || 0) - kit5);
    var pres = Math.min(cand.cents, cap);
    if (pres <= 0) return out;
    var rate = activeRate();
    out.pres = pres;
    out.gbp = rate ? Math.round(pres / rate) : pres;
    out.item = cand.item;
    return out;
  };

  /* Fields appended to the mint payload — contract in REFERRAL-BUILD.md
     §14 (main worker, BUILT 2026-09-09) and SIDE-CART.md §18.

       referralId                    the claim to verify
       referralGiftCents             GBP pence  — the cheapest set UNIT
       referralGiftPresentmentCents  the SAME unit in the shopper's own
                                     currency. REQUIRED off GBP: non-GBP
                                     baskets mint a PERCENTAGE of the
                                     presentment subtotal (A3, 08-13), and
                                     folding GBP pence into that would
                                     reintroduce the FX step A3 closed.
                                     Without it the worker answers
                                     `skipped:no-presentment-gift`.
       lines                         every cart line, one entry per LINE
                                     with per-UNIT prices, so the worker
                                     can cap the gift at the cheapest
                                     `isSet` line it can see for itself.

     The gift is ALSO already inside totalSavingsCents / presentmentCents
     (the fold below puts it there, because the drawer shows it). These
     fields are how the worker finds it again: it subtracts
     referralGiftCents (and referralGiftPresentmentCents on the percentage
     path) and adds back its own verified, capped gift — or nothing, when
     the claim doesn't verify. So the gift is counted exactly once, and an
     unverified claim can never ride the mint.

     Backwards compatible in both directions: absent when there's no
     claim, and ignored by a worker whose referral hunk isn't pasted yet.
     Forwarded by `_mintBasketCode` in assets/hgn-side-cart-kit-checkout.js. */
  HGNSideCart.prototype._referralMintFields = function () {
    var g = this._referralGift();
    if (!g || !g.claim || !g.claim.id) return null;
    var f = { referralId: g.claim.id };
    if (g.gbp > 0) {
      f.referralGiftCents = g.gbp;
      f.referralGiftPresentmentCents = g.pres;
    }
    var rate = activeRate() || 1;
    var lines = [];
    ((this.cart && this.cart.items) || []).forEach(function (it) {
      var pres = unitRetail(it);
      if (!pres) return;
      /* `isSet` decides the worker's cap, so it must mean exactly what
         our own gift candidate means: a full-price wraps / gels /
         press-ons / Mini Me unit, kit design lines included. The free-
         gift line and IR-1 pair / free-4th lines are NOT candidates —
         the pair line's price is already folded, and letting the worker
         cap on it would hand back less than the drawer promised. Packs
         and MTT sets are not sets either (isSetLine, 2026-10-26). */
      var isSet = !isOfferLine(it) && isSetLine(it);
      lines.push({
        priceCents: Math.round(pres / rate),
        presentmentPriceCents: pres,
        quantity: Math.max(1, it.quantity || 1),
        isSet: isSet
      });
    });
    if (lines.length) f.lines = lines;
    return f;
  };

  /* The worker always mints when anything is left to mint; the gift is the
     optional part. `referralGift` comes back as `{ applied, cents,
     presentmentCents, reason }` (worker 2026-09-23; older builds sent a
     bare `skipped:<reason>` string — both are handled). A skip is NEVER a
     blocker — the shopper carries on with whatever else the BASKET-*
     covers, and a gift-only basket gets `noDiscount` (see
     _armCheckoutWithoutDiscount in the kit-checkout asset). Surfaced as a console warning and
     a DOM event so telemetry can see it; there is no generic
     `hgn:checkout` event in this codebase, so this follows the naming of
     the one sibling that exists, `hgn:checkout:mint-failed`. */
  HGNSideCart.prototype._noteReferralMintResult = function (result) {
    if (result == null) return;
    var applied = !!(result && result.applied);
    if (!applied && window.console && console.warn) {
      console.warn('[hgn-side-cart-referral] gift not applied to the mint:', result);
    }
    try {
      document.dispatchEvent(new CustomEvent('hgn:checkout:referral-gift', {
        detail: { referralGift: result, applied: applied }
      }));
    } catch (e) {}
  };

  /* ───────── the fold ─────────
     Mirrors IR-1's `_applyPairFold` exactly, including the back-out: the
     base render resets `_lastSavings*` on most passes but not all, so we
     undo our own previous contribution before adding a fresh one.

     This is the ONLY place the gift joins the totals. The mint sends those
     totals as-is; the worker swaps our claimed gift for its verified one
     (see `_referralMintFields`). Nothing downstream adds it again. */
  HGNSideCart.prototype._applyReferralFold = function () {
    var f = this._referralFold;
    if (f) {
      if (this._lastSavingsGbpCents === f.gbpAfter) this._lastSavingsGbpCents -= f.gbp;
      if (this._lastSavingsCents === f.presAfter) this._lastSavingsCents -= f.pres;
      if (this._lastDisplayedSubtotalCents === f.subAfter) this._lastDisplayedSubtotalCents += f.pres;
      this._referralFold = null;
    }
    var g = this._referralGift();
    this._renderReferralBanner(g);
    this._renderReferralShare(g);
    if (!g || g.pres <= 0) return;

    this._lastSavingsGbpCents = (this._lastSavingsGbpCents || 0) + g.gbp;
    this._lastSavingsCents    = (this._lastSavingsCents || 0) + g.pres;
    this._referralFold = {
      gbp: g.gbp, pres: g.pres,
      gbpAfter: this._lastSavingsGbpCents,
      presAfter: this._lastSavingsCents,
      subAfter: null
    };

    var cur = this.cart.currency;
    if (this.savingsEl && this.savingsValueEl) {
      /* `_lastSavingsCents` excludes the KIT5 fold (the base render adds
         it only at paint time) — re-add it or the row loses ~£5, the same
         trap IR-1's audit P1-5 fixed. */
      var k5 = 0;
      try {
        if (typeof this._kit5FoldGbpCents === 'function' && typeof H.gbpToActiveCents === 'function') {
          k5 = H.gbpToActiveCents((this._kit5FoldGbpCents() || 0) / 100);
        }
      } catch (e) {}
      this.savingsValueEl.textContent = formatMoney(this._lastSavingsCents + k5, cur);
      this.savingsEl.hidden = false;
    }
    if (typeof this._lastDisplayedSubtotalCents === 'number') {
      this._lastDisplayedSubtotalCents = Math.max(0, this._lastDisplayedSubtotalCents - g.pres);
      this._referralFold.subAfter = this._lastDisplayedSubtotalCents;
      if (this.subtotalEl) this.subtotalEl.textContent = formatMoney(this._lastDisplayedSubtotalCents, cur);
    }
    this._markReferralGiftRow(g);
  };

  /* Row treatment on the line that's going free. One UNIT only, so a
     qty-2 line shows retail struck through and one unit's worth off —
     the same convention the pair fold uses. */
  HGNSideCart.prototype._markReferralGiftRow = function (g) {
    if (!g || !g.item || !this.itemsEl) return;
    var it = g.item;
    var cur = this.cart.currency;
    var rows = this.itemsEl.querySelectorAll('.hgn-side-cart__item');
    for (var i = 0; i < rows.length; i++) {
      var a = rows[i].querySelector('.hgn-side-cart__item-title');
      if (!a || String(a.getAttribute('href') || '').indexOf('/products/' + it.handle) === -1) continue;
      var priceEl = rows[i].querySelector('.hgn-side-cart__item-price');
      if (!priceEl || priceEl.getAttribute('data-hgn-referral-done')) continue;
      var retail = it.original_line_price != null ? it.original_line_price : (it.line_price || 0);
      var label = g.claim.firstName ? fill(COPY.rowFree, escapeHtml(g.claim.firstName)) : COPY.rowFreeAnon;
      priceEl.innerHTML = '<s class="hgn-side-cart__item-price--strike">' + formatMoney(retail, cur) + '</s> ' +
        formatMoney(Math.max(0, retail - g.pres), cur) +
        ' <span class="hgn-side-cart__item-referral">' + label + '</span>';
      priceEl.setAttribute('data-hgn-referral-done', '1');
      break;
    }
  };

  /* ───────── banner ───────── */
  HGNSideCart.prototype._referralBannerHost = function () {
    if (this._referralBannerEl && this._referralBannerEl.parentNode) return this._referralBannerEl;
    var body = this.body || document.querySelector('[data-hgn-side-cart-body]');
    if (!body) return null;
    var el = document.createElement('div');
    el.className = 'hgn-side-cart__referral';
    el.setAttribute('data-hgn-referral-banner', '');
    el.hidden = true;
    body.insertBefore(el, body.firstChild);
    this._referralBannerEl = el;
    return el;
  };

  /* Empty bag: the body has no progress strip or lines above the banner, so
     as the body's first child it rode up under the header's close button
     (render 06, 09-09). There it moves INTO the empty state, above "Your bag
     is empty", so the good news sits with the two CTAs that act on it. Any
     other state puts it back as the body's first child. Idempotent DOM moves
     only. */
  HGNSideCart.prototype._placeReferralBanner = function (host, empty) {
    try {
      var emptyEl = this.emptyEl || document.querySelector('[data-hgn-side-cart-empty]');
      var body = this.body || document.querySelector('[data-hgn-side-cart-body]');
      if (empty && emptyEl) {
        if (host.parentNode !== emptyEl || emptyEl.firstChild !== host) emptyEl.insertBefore(host, emptyEl.firstChild);
      } else if (body && (host.parentNode !== body || body.firstChild !== host)) {
        body.insertBefore(host, body.firstChild);
      }
      host.classList.toggle('hgn-side-cart__referral--empty', !!(empty && emptyEl));
    } catch (e) {}
  };

  HGNSideCart.prototype._renderReferralBanner = function (g) {
    var host = this._referralBannerHost();
    if (!host) return;
    if (!g) { host.hidden = true; host.innerHTML = ''; return; }
    var first = g.claim.firstName;
    var line;
    if (!this.cart || !this.cart.item_count) {
      line = first ? fill(COPY.bannerEmpty, first) : COPY.bannerEmptyAnon;
    } else if (g.pres > 0) {
      var inKit = !!(g.item && g.item.properties && /-starter-kit/.test(String(g.item.properties._bundle_type || '')));
      if (inKit) line = first ? fill(COPY.bannerReadyKit, first) : COPY.bannerReadyKitAnon;
      else line = first ? fill(COPY.bannerReady, first) : COPY.bannerReadyAnon;
    } else if (g.deal && (g.sets || 0) < 2) {
      var deal = g.deal === 'both' ? COPY.dealBoth : g.deal === 'mtt' ? COPY.dealMtt : COPY.dealPack;
      if ((g.sets || 0) === 1) line = COPY.bannerDealOne.replace('{deal}', deal);
      else line = (first ? fill(COPY.bannerDealNone, first) : COPY.bannerDealNoneAnon).replace('{deal}', deal);
    } else {
      line = first ? COPY.bannerNeedsOne : COPY.bannerNeedsOneAnon;
    }
    this._placeReferralBanner(host, !this.cart || !this.cart.item_count);
    var state = g.pres > 0 ? 'ready' : 'pending';
    host.setAttribute('data-hgn-referral-state', state);
    host.classList.toggle('is-ready', state === 'ready');
    host.innerHTML =
      '<span class="hgn-side-cart__referral-icon" aria-hidden="true">' +
        '<svg viewBox="0 0 24 24" width="14" height="14" fill="none">' +
          '<path d="M3 8h18v4H3z" stroke="currentColor" stroke-width="1.5"/>' +
          '<path d="M5 12v9h14v-9" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>' +
          '<path d="M12 8v13" stroke="currentColor" stroke-width="1.5"/>' +
          '<path d="M8.5 8C7 6.5 7.5 4 9.5 4 11 4 12 6 12 8c0-2 1-4 2.5-4 2 0 2.5 2.5 1 4" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>' +
        '</svg>' +
      '</span>' +
      '<span class="hgn-side-cart__referral-copy">' + escapeHtml(line) + '</span>';
    host.hidden = false;
  };

  /* ───────── share slots (no claim) ───────── */
  HGNSideCart.prototype._referralShareHost = function () {
    if (this._referralShareEl && this._referralShareEl.parentNode) return this._referralShareEl;
    var body = this.body || document.querySelector('[data-hgn-side-cart-body]');
    if (!body) return null;
    var el = document.createElement('div');
    el.className = 'hgn-side-cart__refer';
    el.setAttribute('data-hgn-referral-share', '');
    el.hidden = true;
    /* Just above the Nail Points panel — after the items, before the
       housekeeping rows, so it reads as an offer and not as chrome. */
    var anchor = this.beansEl || this.adhocEl || null;
    if (anchor && anchor.parentNode === body) body.insertBefore(el, anchor);
    else body.appendChild(el);
    this._referralShareEl = el;
    return el;
  };

  function isRecognisedCustomer() {
    if (window.HGN_CUSTOMER_ID) {
      var r = R();
      if (r && r.isReturning()) return 'returning';
      return 'customer';
    }
    return null;
  }

  HGNSideCart.prototype._renderReferralShare = function (g) {
    var host = this._referralShareHost();
    if (!host) return;
    /* A live claim owns the drawer — no asking a first-order friend to
       refer anyone before they've bought. */
    if (g) { host.hidden = true; host.innerHTML = ''; this._referralShareMode = null; return; }
    var who = isRecognisedCustomer();
    /* "Sent by a friend? Claim your free set" (Name Share, below) is retired
       from the drawer for everyone (Matt, 2026-10-07: 3 claims ever, and it
       told every shopper some people get a free set). A friend who arrived
       on a link gets _renderReferralPrompt instead; the landing page keeps
       its own Name Share. */
    var mode = who === 'returning' ? 'refer' : null;
    if (!mode) { host.hidden = true; host.innerHTML = ''; this._referralShareMode = null; return; }
    if (this._referralShareMode === mode && host.innerHTML) { host.hidden = false; return; }
    this._referralShareMode = mode;
    if (mode === 'refer') this._paintReferSlot(host);
    else this._paintNameShare(host);
    host.hidden = false;
  };

  /* Returning customer: the ask. */
  HGNSideCart.prototype._paintReferSlot = function (host) {
    host.setAttribute('data-hgn-referral-mode', 'refer');
    host.innerHTML =
      '<p class="hgn-side-cart__refer-title">' + escapeHtml(COPY.referTitle) + '</p>' +
      '<p class="hgn-side-cart__refer-sub">' + escapeHtml(COPY.referSub) + '</p>' +
      '<div class="hgn-side-cart__refer-actions">' +
        '<button type="button" class="hgn-side-cart__refer-btn" data-hgn-referral-wa>' +
          (navigator.share ? escapeHtml(COPY.referShare) : escapeHtml(COPY.referWa)) + '</button>' +
        '<button type="button" class="hgn-side-cart__refer-btn hgn-side-cart__refer-btn--ghost" data-hgn-referral-copy>' +
          escapeHtml(COPY.referCopy) + '</button>' +
      '</div>';
    applyFx(host);

    var self = this;
    var waBtn = host.querySelector('[data-hgn-referral-wa]');
    var copyBtn = host.querySelector('[data-hgn-referral-copy]');
    function withLink(fn) {
      self._referralLink().then(function (acc) {
        if (!acc || !acc.link) return;
        fn(acc);
      }).catch(function () {});
    }
    if (waBtn) waBtn.addEventListener('click', function () {
      withLink(function (acc) {
        var r = R();
        if (r) r.share(acc.link, acc.code, 'side-cart');
      });
    });
    if (copyBtn) copyBtn.addEventListener('click', function () {
      withLink(function (acc) {
        var r = R();
        if (r) {
          r.copy(acc.link);
          r.shareClick(acc.code, 'copy', 'side-cart');
        }
        copyBtn.textContent = COPY.referCopied;
        setTimeout(function () { copyBtn.textContent = COPY.referCopy; }, 1600);
      });
    });
  };

  /* The pill's own source of truth — one proxy call, cached per drawer
     instance so tapping both buttons doesn't fetch twice. */
  HGNSideCart.prototype._referralLink = function () {
    if (this._referralAccountPromise) return this._referralAccountPromise;
    var email = window.HGN_CUSTOMER_EMAIL;
    if (!email) return Promise.resolve(null);
    this._referralAccountPromise = fetch(ACCOUNT_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || d.ok === false || !d.referral_link) return null;
        return { link: d.referral_link, code: d.referral_code || '' };
      })
      .catch(function () { return null; });
    return this._referralAccountPromise;
  };

  /* Arrived on a friend's link, no claim yet (2026-10-07). The capture
     snippet keeps the link's code for 30 days (hgn-ref) but the drawer used
     to ignore it; the claim itself happens on /pages/from-a-friend. One
     quiet line under the lines, linking there with the code on the URL —
     the landing page reads ?ref= first. Not for a returning customer (the
     gift is for first orders), not over a claim (the banner owns that), not
     in the empty bag. Both arms. */
  HGNSideCart.prototype._renderReferralPrompt = function () {
    var host = this._referralPromptEl;
    var r = R();
    var code = null, show = false;
    try {
      code = r ? r.code() : null;
      var attr = String(((this.cart || {}).attributes || {})._hgn_referral_claim || '');
      show = !!(code && this.cart && this.cart.item_count && !r.claim() && !attr && !r.isReturning());
    } catch (e) { show = false; }
    if (!show) { if (host) { host.hidden = true; host.innerHTML = ''; } return; }
    var anchor = this.cartSectionEl;
    if (!anchor || !anchor.parentNode) return;
    if (!host) {
      host = document.createElement('div');
      host.className = 'hgn-side-cart__ref-prompt';
      host.setAttribute('data-hgn-referral-prompt', '');
      host.addEventListener('click', function (e) {
        if (!e.target || !e.target.closest || !e.target.closest('a')) return;
        try { document.dispatchEvent(new CustomEvent('hgn:offer:declutter_ref_prompt_tap', { detail: {} })); } catch (err) {}
        try { if (typeof window.clarity === 'function') window.clarity('set', 'hgn_offer_declutter_ref_prompt_tap', '1'); } catch (err) {}
      });
      this._referralPromptEl = host;
    }
    /* Directly under the lines, above the add row — re-asserted every render
       because the attach row and the kit card move themselves. */
    if (anchor.nextSibling !== host) anchor.parentNode.insertBefore(host, anchor.nextSibling);
    var href = '/pages/from-a-friend?ref=' + encodeURIComponent(code);
    if (host.getAttribute('data-hgn-ref-href') !== href) {
      host.setAttribute('data-hgn-ref-href', href);
      host.innerHTML = '<a class="hgn-side-cart__ref-prompt-link" href="' + escapeHtml(href) + '">' + escapeHtml(COPY.refPrompt) + '</a>';
    }
    host.hidden = false;
  };

  /* Name Share: an unrecognised visitor whose friend told them a name
     rather than sending a link. Two fields, three outcomes. No longer
     painted in the drawer (see _renderReferralShare, 2026-10-07); kept for
     the record and an easy way back. */
  HGNSideCart.prototype._paintNameShare = function (host) {
    host.setAttribute('data-hgn-referral-mode', 'nameshare');
    host.innerHTML =
      '<button type="button" class="hgn-side-cart__refer-teaser" data-hgn-referral-teaser aria-expanded="false">' +
        escapeHtml(COPY.nameShareTeaser) +
      '</button>' +
      '<div class="hgn-side-cart__refer-form" data-hgn-referral-form hidden>' +
        '<label class="hgn-side-cart__refer-prompt" for="hgn-referral-name">' + escapeHtml(COPY.nameSharePrompt) + '</label>' +
        '<input type="text" class="hgn-side-cart__refer-input" id="hgn-referral-name" data-hgn-referral-name ' +
          'placeholder="' + escapeHtml(COPY.nameShareName) + '" autocomplete="off" autocapitalize="words" spellcheck="false">' +
        '<input type="email" class="hgn-side-cart__refer-input" data-hgn-referral-email ' +
          'placeholder="' + escapeHtml(COPY.nameShareEmail) + '" autocomplete="email" inputmode="email">' +
        '<input type="email" class="hgn-side-cart__refer-input" data-hgn-referral-refemail ' +
          'placeholder="' + escapeHtml(COPY.nameShareRef) + '" autocomplete="off" inputmode="email" hidden>' +
        '<input type="text" class="hgn-side-cart__refer-hp" data-hgn-referral-hp tabindex="-1" autocomplete="off" aria-hidden="true">' +
        '<button type="button" class="hgn-side-cart__refer-btn" data-hgn-referral-submit>' +
          escapeHtml(COPY.nameShareCta) + '</button>' +
        '<p class="hgn-side-cart__refer-msg" data-hgn-referral-msg hidden></p>' +
      '</div>';

    var self = this;
    var teaser = host.querySelector('[data-hgn-referral-teaser]');
    var form   = host.querySelector('[data-hgn-referral-form]');
    var nameIn = host.querySelector('[data-hgn-referral-name]');
    var mailIn = host.querySelector('[data-hgn-referral-email]');
    var refIn  = host.querySelector('[data-hgn-referral-refemail]');
    var hp     = host.querySelector('[data-hgn-referral-hp]');
    var submit = host.querySelector('[data-hgn-referral-submit]');
    var msg    = host.querySelector('[data-hgn-referral-msg]');

    if (window.HGN_CUSTOMER_EMAIL && mailIn) mailIn.value = window.HGN_CUSTOMER_EMAIL;

    function say(text) {
      if (!msg) return;
      msg.textContent = text || '';
      msg.hidden = !text;
    }
    if (teaser) teaser.addEventListener('click', function () {
      var open = !form.hidden;
      form.hidden = open;
      teaser.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (!open && nameIn) nameIn.focus();
    });

    if (submit) submit.addEventListener('click', function () {
      var name = (nameIn && nameIn.value || '').trim();
      var mail = (mailIn && mailIn.value || '').trim();
      if (!name || !mail || mail.indexOf('@') === -1) { say(COPY.nameShareMissing); return; }
      submit.disabled = true;
      say('');
      var body = {
        name: name,
        email: mail,
        source: 'name_share',
        surface: 'side-cart',
        landing_path: location.pathname
      };
      /* Honeypot stays ADVISORY (popup honeypot incident, 09-09):
         autofill fills hidden fields and we will NOT drop a signup for
         it. Reported, never enforced. */
      if (hp && hp.value) body.hp = hp.value;
      if (refIn && !refIn.hidden && refIn.value.trim()) body.referrer_email = refIn.value.trim();
      fetch(API + '/hgn/referral/name-share', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'omit',
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().catch(function () { return null; }); })
        .then(function (d) {
          submit.disabled = false;
          if (!d) { say(COPY.nameShareErr); return; }
          if (d.ambiguous) {
            if (refIn) { refIn.hidden = false; refIn.focus(); }
            say(COPY.nameShareAmbig);
            return;
          }
          if (!d.ok && (d.reason === 'referrer-excluded' || d.reason === 'name-share-cap')) {
            say(COPY.nameShareRefused);
            return;
          }
          if (!d.ok || !d.referral_id) {
            /* No match: the copy offers the friend's email as the way in,
               so the field has to be there to type it into. */
            if (refIn && refIn.hidden) refIn.hidden = false;
            say(COPY.nameShareNone);
            return;
          }
          var r = R();
          var done = r ? r.setClaim({
            referral_id: d.referral_id,
            first_name: d.referrer_first_name || '',
            expires_at: d.expires_at || ''
          }) : Promise.resolve();
          done.then(function () { return self.refresh(); }).catch(function () {});
        })
        .catch(function () { submit.disabled = false; say(COPY.nameShareErr); });
    });
  };

  /* ═══════════ suppression while a claim is live ═══════════ */

  function claimLive(self) { return !!self._referralClaim(); }

  /* Blanking the configured gift tiers is the one lever that turns off
     the whole free-gift ladder in one move: `_orchestrateFreeGift`
     returns at its `if (!tier) return;` guard, `_renderProgress` computes
     `giftConfigured` false (milestone hidden, copy narrates shipping
     only), and IR-1's ladder-early appendix finds no gift name. */
  function withGiftOff(self, fn, args) {
    var cfg = self.config && self.config.gift;
    if (!cfg || !cfg.tiers) return fn.apply(self, args);
    var prev = cfg.tiers;
    cfg.tiers = [];
    try { return fn.apply(self, args); } finally { cfg.tiers = prev; }
  }

  var origOrchestrateGift = HGNSideCart.prototype._orchestrateFreeGift;
  if (typeof origOrchestrateGift === 'function') {
    HGNSideCart.prototype._orchestrateFreeGift = function () {
      if (!claimLive(this)) return origOrchestrateGift.apply(this, arguments);
      /* Blanking the tiers alone would leave an ALREADY-ADDED gift line
         sitting in the bag forever, so remove it explicitly — same
         inflight guard the orchestrator itself uses. */
      var giftLine = ((this.cart && this.cart.items) || []).filter(isGiftLineItem)[0];
      if (giftLine && !this._giftInflight && typeof this._removeGiftLine === 'function') {
        var self = this;
        this._giftInflight = true;
        this._removeGiftLine(giftLine).then(function () { self._giftInflight = false; })
          .catch(function () { self._giftInflight = false; });
      }
      return undefined;
    };
  }

  /* The meter must narrate the money Shopify will actually rate shipping
     on. IR-1 lends its pair savings to `_lastAdHocSavingsCents` around the
     original call for exactly this reason; the gift is lent the same way.
     Computed fresh rather than read off `_referralFold`, because
     `_renderProgress` runs INSIDE the base render, i.e. before this pass's
     fold has been applied. */
  function withGiftLent(self, fn, args) {
    var extra = 0;
    try { var g = self._referralGift(); extra = (g && g.pres) || 0; } catch (e) { extra = 0; }
    if (!extra) return fn.apply(self, args);
    var prev = self._lastAdHocSavingsCents || 0;
    self._lastAdHocSavingsCents = prev + extra;
    try { return fn.apply(self, args); } finally { self._lastAdHocSavingsCents = prev; }
  }

  var origRenderProgress = HGNSideCart.prototype._renderProgress;
  if (typeof origRenderProgress === 'function') {
    HGNSideCart.prototype._renderProgress = function () {
      if (!claimLive(this)) return origRenderProgress.apply(this, arguments);
      var self = this, args = arguments;
      return withGiftOff(this, function () {
        return withGiftLent(self, origRenderProgress, args);
      }, []);
    };
  }

  /* IR-1 pair / free-4th card: never pitched over a claim. Both hooks —
     the eligibility gate stops a fresh card, the show hook closes one
     that was already up when the claim landed. */
  var origPairEligible = HGNSideCart.prototype._pairEligible;
  if (typeof origPairEligible === 'function') {
    HGNSideCart.prototype._pairEligible = function () {
      if (claimLive(this)) return false;
      return origPairEligible.apply(this, arguments);
    };
  }
  var origMaybeShowOffer = HGNSideCart.prototype._maybeShowOffer;
  if (typeof origMaybeShowOffer === 'function') {
    HGNSideCart.prototype._maybeShowOffer = function () {
      if (claimLive(this)) {
        if (this._pairOfferOpen && typeof this._hidePairOffer === 'function') this._hidePairOffer();
        return undefined;
      }
      return origMaybeShowOffer.apply(this, arguments);
    };
  }

  /* IR-1 kit nudge (arm B, `_applyKitNudge` in assets/hgn-side-cart-attach.js,
     live since 09-20): same rule as the pair card — no second offer pitched
     over a claim. The nudge dresses the kit upsell with its own money copy
     ("Save 37% · £X off") from a contribution gate that cannot see the free
     set, so over a claim it would price the wrong basket. Handing it a
     BLOCKED verdict uses the nudge's own blocked path: card hidden, ordering
     stood down so the attach row goes back to its usual place, and
     `_kitNudgeActive` cleared. Arm A (the plain kit card, which carries no
     offer maths) is untouched, as is every basket without a claim. */
  var origApplyKitNudge = HGNSideCart.prototype._applyKitNudge;
  if (typeof origApplyKitNudge === 'function') {
    HGNSideCart.prototype._applyKitNudge = function (gate) {
      if (gate && gate.allowed && claimLive(this)) {
        var blocked = {};
        for (var k in gate) if (Object.prototype.hasOwnProperty.call(gate, k)) blocked[k] = gate[k];
        blocked.allowed = false;
        blocked.reason = 'referral-claim';
        this._kitNudgeGate = blocked;
        return origApplyKitNudge.call(this, blocked);
      }
      return origApplyKitNudge.apply(this, arguments);
    };
  }

  /* ═══════════ render + checkout wiring ═══════════ */

  /* The main file keeps its instance in closure scope and exposes only a
     small API object, so — exactly as the attach snippet does for its kit
     commit — we hold onto `this` from the render pipeline for the debug
     helper below. */
  var mounted = null;

  var origRender = HGNSideCart.prototype._render;
  HGNSideCart.prototype._render = function () {
    mounted = this;
    /* Live-verification handle: the main file keeps its instance in
       closure scope and exposes only a small API object, so there is no
       other way to poke the drawer from a console or a probe. */
    try { window.__probeInstance = this; } catch (e) {}
    var out = origRender.apply(this, arguments);
    try {
      this._applyReferralFold();
      this._renderReferralPrompt();
      /* Nail Points + "Have a code?" are the two other ways to pay less,
         and neither stacks with the gift. Hidden, not disabled: an
         inert control is worse than no control. */
      var live = claimLive(this);
      if (this.beansEl && live) this.beansEl.hidden = true;
      if (this.adhocEl && live) this.adhocEl.hidden = true;
    } catch (e) {
      if (window.console && console.warn) console.warn('[hgn-side-cart-referral]', e);
    }
    return out;
  };

  /* Checkout-click must always run the mint path when a claim can pay
     for something, even on a bag with no kit, no points and no pair.
     The fold normally guarantees that (it lands in `_lastSavingsGbpCents`
     during _render), but a click that beats a render — or a render that
     ran before the claim was written — would otherwise take the plain
     `/checkout` route and lose the gift. Re-folding is idempotent: the
     fold backs its own previous contribution out first. */
  var origProceed = HGNSideCart.prototype._proceedToCheckout;
  HGNSideCart.prototype._proceedToCheckout = function (opts) {
    try {
      if (claimLive(this) && !(opts && opts.skipMint)) {
        var g = this._referralGift();
        if (g && g.pres > 0 && !this._referralFold) this._applyReferralFold();
      }
    } catch (e) {}
    return origProceed.apply(this, arguments);
  };

  /* The claim can land while the drawer is already open (Name Share
     here, or the landing page in another tab). Repaint on the capture
     snippet's broadcast. */
  try {
    document.addEventListener('hgn:referral:change', function () {
      try {
        var sc = window.HGN && window.HGN.sideCart;
        if (sc && typeof sc.refresh === 'function') sc.refresh();
      } catch (e) {}
    });
  } catch (e) {}

  /* Console answer to "why is there no gift?" — one line per state. */
  window.HGN = window.HGN || {};
  window.HGN.referralDebug = function () {
    try {
      var inst = mounted;
      if (!inst) return { note: 'side cart has not rendered yet' };
      var g = inst._referralGift();
      return {
        claim: inst._referralClaim(),
        gift: g ? { sets: g.sets, deal: g.deal || '', pres: g.pres, gbp: g.gbp, handle: g.item && g.item.handle } : null,
        mintFields: inst._referralMintFields(),
        fold: inst._referralFold || null
      };
    } catch (e) { return { error: String(e && e.message || e) }; }
  };
})();
